import React from "react";

import { cn } from "helpers/style";
import styles from "./Loader.module.scss";

type Props = {
  spinnerColor?: string;
  small?: boolean;
  className?: string;
};

const Loader = React.memo(
  ({ small, spinnerColor = "black", className }: Props) => {
    return (
      <svg
        className={cn([
          styles.spinnerContainer,
          small && styles.spinnerContainerSmall,
          className,
        ])}
      >
        <circle
          className={cn([
            styles.spinner,
            spinnerColor === "black" && styles.spinnerBlack,
            spinnerColor === "white" && styles.spinnerWhite,
            spinnerColor === "orange" && styles.spinnerOrange,
          ])}
        />
      </svg>
    );
  }
);

Loader.displayName = "Loader";
export default Loader;
